import { retry, cached } from '../../async';
import { PurchaseFailReason } from './PurchaseFailReason';
import { Categorizer } from '../../../report';

declare global {
    interface Window {
        FBInstant?: typeof FBInstant;
    }
}

export const getFBInstant: () => Promise<typeof FBInstant> = cached(() => {
    const startedAt = Date.now();
    const timeoutMs = 20000;
    return retry(
        () => {
            if (typeof window.FBInstant !== 'undefined') {
                return window.FBInstant;
            }
            throw new Error('FBInstant is not defined');
        },
        {
            getRetryDelayMs: () => {
                const elapsed = Date.now() - startedAt;
                if (elapsed >= timeoutMs) return undefined;
                return 100;
            },
        }
    ).promise;
});

export function isAPISupported(featureName: string) {
    return FBInstant.getSupportedAPIs().includes(featureName);
}

export function retryFBOperation<T>(debugOperationName: string, fbOperation: () => Promise<T>, fallback: T) {
    return retry(async () => {
        try {
            return await fbOperation();
        } catch (error) {
            if (error && error.code === 'CLIENT_UNSUPPORTED_OPERATION') {
                console.info(`fbOperation "${debugOperationName}" is not supported`);
                return fallback;
            }
            console.warn(`fbOperation "${debugOperationName}" failed`, error);
            throw error;
        }
    });
}

export function isNetworkFailureError(error: any) {
    return Boolean(error && error.code === 'NETWORK_FAILURE');
}

export function isUserInputError(error: any) {
    return error?.code === PurchaseFailReason.USER_INPUT || /\b(?:user canceled)\b/i.test(String(error?.message));
}

//

export function fbPendingRequestCategorizer(funcName: string): Categorizer {
    return (error: any) => {
        if (/\b(pending request for locking message)\b/i.test(String(error?.message))) {
            return {
                fingerprint: 'fbPendingRequest',
                tags: {
                    funcName,
                },
            };
        }
    };
}
